// GENERATED FILE — do not edit.
//
// Source:      packages/maptool/maps/depot.txt
// Regenerate:  npm run maps -w @prop-hunt/maptool
// mapHash:     0xfef46a8b
//
// 40 x 28 cells at 2m = 80m x 56m (x -40..40, z -28..28)
// 87 collision solids, 101 props, 12 spawns
//
// Editing this file by hand desynchronises it from the ASCII plan, which is
// the artefact the level actually lives in. Edit the source and regenerate.

import { MAP_FORMAT_VERSION, type GameMap } from "../mapfmt.js";

export const DEPOT_MAP: GameMap = {
  formatVersion: MAP_FORMAT_VERSION,
  name: "depot",
  solids: [
    { x: 0, y: -1, z: 0, w: 80, h: 1, d: 56 },
    { x: 0, y: 0, z: -27, w: 80, h: 4, d: 2 },
    { x: -39, y: 0, z: 1, w: 2, h: 4, d: 54 },
    { x: -21, y: 0, z: -22, w: 2, h: 4, d: 8 },
    { x: 7, y: 0, z: -22, w: 2, h: 4, d: 8 },
    { x: 15, y: 0, z: -22, w: 2, h: 4, d: 8 },
    { x: 27, y: 0, z: -22, w: 2, h: 4, d: 8 },
    { x: 39, y: 0, z: 1, w: 2, h: 4, d: 54 },
    { x: -11, y: 0, z: -20, w: 2, h: 4, d: 8 },
    { x: -3, y: 0, z: -20, w: 2, h: 4, d: 8 },
    { x: 9, y: 0, z: -19, w: 2, h: 4, d: 2 },
    { x: 13, y: 0, z: -19, w: 2, h: 4, d: 2 },
    { x: 22, y: 0, z: -19, w: 8, h: 4, d: 2 },
    { x: 31, y: 0, z: -15, w: 2, h: 4, d: 10 },
    { x: 36, y: 0, z: -19, w: 4, h: 4, d: 2 },
    { x: -33, y: 0, z: -17, w: 2, h: 4, d: 2 },
    { x: -27, y: 0, z: -17, w: 2, h: 4, d: 2 },
    { x: 19, y: 0, z: -14, w: 2, h: 4, d: 8 },
    { x: -33, y: 0, z: -13, w: 2, h: 4, d: 2 },
    { x: -27, y: 0, z: -13, w: 2, h: 4, d: 2 },
    { x: -21, y: 0, z: -7, w: 2, h: 4, d: 14 },
    { x: -11, y: 0, z: -11, w: 2, h: 4, d: 6 },
    { x: -3, y: 0, z: -11, w: 2, h: 4, d: 6 },
    { x: 7, y: 0, z: -7, w: 2, h: 4, d: 14 },
    { x: 9, y: 0, z: -11, w: 2, h: 4, d: 2 },
    { x: 14, y: 0, z: -11, w: 4, h: 4, d: 2 },
    { x: 24, y: 0, z: -11, w: 8, h: 4, d: 2 },
    { x: 36, y: 0, z: -11, w: 4, h: 4, d: 2 },
    { x: 15, y: 0, z: -6, w: 2, h: 4, d: 8 },
    { x: 27, y: 0, z: -5, w: 2, h: 4, d: 10 },
    { x: -30, y: 0, z: -3, w: 16, h: 4, d: 2 },
    { x: -17, y: 0, z: -2, w: 6, h: 4, d: 4 },
    { x: -6, y: 0, z: -3, w: 8, h: 4, d: 2 },
    { x: 4, y: 0, z: -2, w: 4, h: 4, d: 4 },
    { x: 10, y: 0, z: -2, w: 4, h: 4, d: 4 },
    { x: 21, y: 0, z: -3, w: 10, h: 4, d: 2 },
    { x: 30, y: 0, z: -3, w: 4, h: 4, d: 2 },
    { x: 36, y: 0, z: -3, w: 4, h: 4, d: 2 },
    { x: -24, y: 0, z: -1, w: 4, h: 4, d: 2 },
    { x: 22, y: 0, z: -1, w: 8, h: 4, d: 2 },
    { x: 29, y: 0, z: -1, w: 2, h: 4, d: 2 },
    { x: -35, y: 0, z: 2, w: 6, h: 4, d: 4 },
    { x: -9, y: 0, z: 2, w: 6, h: 4, d: 4 },
    { x: 35, y: 0, z: 2, w: 6, h: 4, d: 4 },
    { x: -23, y: 0, z: 3, w: 10, h: 4, d: 2 },
    { x: -14, y: 0, z: 3, w: 4, h: 4, d: 2 },
    { x: 4, y: 0, z: 3, w: 12, h: 4, d: 2 },
    { x: 20, y: 0, z: 3, w: 12, h: 4, d: 2 },
    { x: 31, y: 0, z: 3, w: 2, h: 4, d: 2 },
    { x: -11, y: 0, z: 9, w: 2, h: 4, d: 10 },
    { x: 19, y: 0, z: 9, w: 2, h: 4, d: 10 },
    { x: -23, y: 0, z: 10, w: 2, h: 4, d: 8 },
    { x: -5, y: 0, z: 11, w: 2, h: 4, d: 6 },
    { x: 1, y: 0, z: 11, w: 2, h: 4, d: 6 },
    { x: 7, y: 0, z: 11, w: 2, h: 4, d: 6 },
    { x: 13, y: 0, z: 11, w: 2, h: 4, d: 6 },
    { x: 29, y: 0, z: 11, w: 10, h: 4, d: 2 },
    { x: -27, y: 0, z: 13, w: 6, h: 4, d: 2 },
    { x: -11, y: 0, z: 23, w: 2, h: 4, d: 10 },
    { x: 19, y: 0, z: 23, w: 2, h: 4, d: 10 },
    { x: -23, y: 0, z: 24, w: 2, h: 4, d: 8 },
    { x: -5, y: 0, z: 24, w: 2, h: 4, d: 8 },
    { x: 1, y: 0, z: 24, w: 2, h: 4, d: 8 },
    { x: 7, y: 0, z: 24, w: 2, h: 4, d: 8 },
    { x: 13, y: 0, z: 24, w: 2, h: 4, d: 8 },
    { x: -31, y: 0, z: 27, w: 14, h: 4, d: 2 },
    { x: -17, y: 0, z: 27, w: 10, h: 4, d: 2 },
    { x: -8, y: 0, z: 27, w: 4, h: 4, d: 2 },
    { x: -2, y: 0, z: 27, w: 4, h: 4, d: 2 },
    { x: 4, y: 0, z: 27, w: 4, h: 4, d: 2 },
    { x: 10, y: 0, z: 27, w: 4, h: 4, d: 2 },
    { x: 16, y: 0, z: 27, w: 4, h: 4, d: 2 },
    { x: 29, y: 0, z: 27, w: 18, h: 4, d: 2 },
    { x: -28, y: 0, z: -19, w: 4, h: 0.9, d: 2 },
    { x: -11, y: 0, z: -15, w: 2, h: 0.9, d: 2 },
    { x: -3, y: 0, z: -15, w: 2, h: 0.9, d: 2 },
    { x: -32, y: 0, z: -11, w: 4, h: 0.9, d: 2 },
    { x: -5, y: 0, z: 15, w: 2, h: 0.9, d: 2 },
    { x: 1, y: 0, z: 15, w: 2, h: 0.9, d: 2 },
    { x: 7, y: 0, z: 15, w: 2, h: 0.9, d: 2 },
    { x: 13, y: 0, z: 15, w: 2, h: 0.9, d: 2 },
    { x: -31, y: 0, z: 17, w: 6, h: 0.9, d: 2 },
    { x: -19, y: 0, z: 17, w: 6, h: 0.9, d: 2 },
    { x: -5, y: 0, z: 19, w: 2, h: 0.9, d: 2 },
    { x: 1, y: 0, z: 19, w: 2, h: 0.9, d: 2 },
    { x: 7, y: 0, z: 19, w: 2, h: 0.9, d: 2 },
    { x: 13, y: 0, z: 19, w: 2, h: 0.9, d: 2 },
  ],
  props: [
    { prop: 5, x: 9, y: 0, z: -25, yaw: 3.141593 },
    { prop: 5, x: 13, y: 0, z: -25, yaw: 4.712389 },
    { prop: 3, x: 19, y: 0, z: -25, yaw: 0.785398 },
    { prop: 3, x: 23, y: 0, z: -25, yaw: 2.356194 },
    { prop: 5, x: 31, y: 0, z: -25, yaw: 5.497787 },
    { prop: 5, x: 35, y: 0, z: -25, yaw: 0.785398 },
    { prop: 1, x: -19, y: 0, z: -23, yaw: 3.926991 },
    { prop: 1, x: -15, y: 0, z: -23, yaw: 2.356194 },
    { prop: 6, x: -1, y: 0, z: -23, yaw: 3.141593 },
    { prop: 6, x: 3, y: 0, z: -23, yaw: 1.570796 },
    { prop: 5, x: 9, y: 0, z: -21, yaw: 4.712389 },
    { prop: 5, x: 13, y: 0, z: -21, yaw: 3.141593 },
    { prop: 3, x: 19, y: 0, z: -21, yaw: 2.356194 },
    { prop: 3, x: 23, y: 0, z: -21, yaw: 0.785398 },
    { prop: 5, x: 31, y: 0, z: -21, yaw: 3.926991 },
    { prop: 5, x: 35, y: 0, z: -21, yaw: 2.356194 },
    { prop: 1, x: -19, y: 0, z: -19, yaw: 2.356194 },
    { prop: 1, x: -15, y: 0, z: -19, yaw: 3.926991 },
    { prop: 6, x: -1, y: 0, z: -19, yaw: 1.570796 },
    { prop: 6, x: 3, y: 0, z: -19, yaw: 3.141593 },
    { prop: 5, x: 23, y: 0, z: -17, yaw: 5.497787 },
    { prop: 5, x: 27, y: 0, z: -17, yaw: 0.785398 },
    { prop: 5, x: 37, y: 0, z: -17, yaw: 4.712389 },
    { prop: 2, x: -19, y: 0, z: -13, yaw: 0 },
    { prop: 2, x: -15, y: 0, z: -13, yaw: 4.712389 },
    { prop: 3, x: -1, y: 0, z: -13, yaw: 0.785398 },
    { prop: 3, x: 3, y: 0, z: -13, yaw: 5.497787 },
    { prop: 5, x: 23, y: 0, z: -13, yaw: 3.926991 },
    { prop: 5, x: 27, y: 0, z: -13, yaw: 2.356194 },
    { prop: 5, x: 37, y: 0, z: -13, yaw: 3.141593 },
    { prop: 2, x: -19, y: 0, z: -9, yaw: 4.712389 },
    { prop: 2, x: -15, y: 0, z: -9, yaw: 0 },
    { prop: 3, x: -1, y: 0, z: -9, yaw: 5.497787 },
    { prop: 3, x: 3, y: 0, z: -9, yaw: 0.785398 },
    { prop: 5, x: 9, y: 0, z: -9, yaw: 3.141593 },
    { prop: 5, x: 13, y: 0, z: -9, yaw: 4.712389 },
    { prop: 3, x: 19, y: 0, z: -9, yaw: 0.785398 },
    { prop: 3, x: 23, y: 0, z: -9, yaw: 2.356194 },
    { prop: 3, x: 31, y: 0, z: -9, yaw: 5.497787 },
    { prop: 3, x: 35, y: 0, z: -9, yaw: 0.785398 },
    { prop: 5, x: 9, y: 0, z: -5, yaw: 4.712389 },
    { prop: 3, x: 19, y: 0, z: -5, yaw: 2.356194 },
    { prop: 3, x: 23, y: 0, z: -5, yaw: 0.785398 },
    { prop: 3, x: 31, y: 0, z: -5, yaw: 3.926991 },
    { prop: 3, x: 35, y: 0, z: -5, yaw: 2.356194 },
    { prop: 2, x: -35, y: 0, z: 7, yaw: 4.712389 },
    { prop: 2, x: -31, y: 0, z: 7, yaw: 0 },
    { prop: 6, x: -21, y: 0, z: 7, yaw: 3.926991 },
    { prop: 6, x: -17, y: 0, z: 7, yaw: 5.497787 },
    { prop: 2, x: 23, y: 0, z: 7, yaw: 2.356194 },
    { prop: 2, x: 27, y: 0, z: 7, yaw: 3.926991 },
    { prop: 2, x: 31, y: 0, z: 7, yaw: 5.497787 },
    { prop: 2, x: 35, y: 0, z: 7, yaw: 0.785398 },
    { prop: 2, x: -35, y: 0, z: 11, yaw: 3.141593 },
    { prop: 2, x: -31, y: 0, z: 11, yaw: 1.570796 },
    { prop: 6, x: -21, y: 0, z: 11, yaw: 5.497787 },
    { prop: 6, x: -17, y: 0, z: 11, yaw: 3.926991 },
    { prop: 3, x: -7, y: 0, z: 11, yaw: 4.712389 },
    { prop: 3, x: -1, y: 0, z: 11, yaw: 3.926991 },
    { prop: 1, x: 5, y: 0, z: 11, yaw: 0 },
    { prop: 1, x: 11, y: 0, z: 11, yaw: 5.497787 },
    { prop: 3, x: 17, y: 0, z: 11, yaw: 1.570796 },
    { prop: 3, x: -7, y: 0, z: 13, yaw: 0.785398 },
    { prop: 3, x: -1, y: 0, z: 13, yaw: 1.570796 },
    { prop: 1, x: 5, y: 0, z: 13, yaw: 5.497787 },
    { prop: 1, x: 11, y: 0, z: 13, yaw: 0 },
    { prop: 3, x: 17, y: 0, z: 13, yaw: 3.926991 },
    { prop: 1, x: 23, y: 0, z: 13, yaw: 4.712389 },
    { prop: 1, x: 27, y: 0, z: 13, yaw: 0 },
    { prop: 1, x: 31, y: 0, z: 13, yaw: 1.570796 },
    { prop: 1, x: 35, y: 0, z: 13, yaw: 3.141593 },
    { prop: 4, x: -33, y: 0, z: 15, yaw: 2.356194 },
    { prop: 4, x: -21, y: 0, z: 15, yaw: 0.785398 },
    { prop: 5, x: 23, y: 0, z: 17, yaw: 3.141593 },
    { prop: 5, x: 27, y: 0, z: 17, yaw: 1.570796 },
    { prop: 5, x: 31, y: 0, z: 17, yaw: 0 },
    { prop: 5, x: 35, y: 0, z: 17, yaw: 4.712389 },
    { prop: 4, x: -33, y: 0, z: 19, yaw: 0.785398 },
    { prop: 4, x: -21, y: 0, z: 19, yaw: 2.356194 },
    { prop: 6, x: -35, y: 0, z: 21, yaw: 5.497787 },
    { prop: 6, x: -31, y: 0, z: 21, yaw: 0.785398 },
    { prop: 2, x: -21, y: 0, z: 21, yaw: 3.141593 },
    { prop: 2, x: -17, y: 0, z: 21, yaw: 4.712389 },
    { prop: 4, x: -7, y: 0, z: 21, yaw: 3.926991 },
    { prop: 4, x: -1, y: 0, z: 21, yaw: 4.712389 },
    { prop: 2, x: 5, y: 0, z: 21, yaw: 2.356194 },
    { prop: 2, x: 11, y: 0, z: 21, yaw: 3.141593 },
    { prop: 4, x: 17, y: 0, z: 21, yaw: 0.785398 },
    { prop: 3, x: 23, y: 0, z: 21, yaw: 1.570796 },
    { prop: 3, x: 27, y: 0, z: 21, yaw: 3.141593 },
    { prop: 3, x: 31, y: 0, z: 21, yaw: 4.712389 },
    { prop: 3, x: 35, y: 0, z: 21, yaw: 0 },
    { prop: 4, x: -7, y: 0, z: 23, yaw: 3.141593 },
    { prop: 4, x: -1, y: 0, z: 23, yaw: 5.497787 },
    { prop: 2, x: 5, y: 0, z: 23, yaw: 1.570796 },
    { prop: 2, x: 11, y: 0, z: 23, yaw: 3.926991 },
    { prop: 4, x: 17, y: 0, z: 23, yaw: 0 },
    { prop: 6, x: -35, y: 0, z: 25, yaw: 3.926991 },
    { prop: 6, x: -31, y: 0, z: 25, yaw: 2.356194 },
    { prop: 2, x: -21, y: 0, z: 25, yaw: 4.712389 },
    { prop: 2, x: -17, y: 0, z: 25, yaw: 3.141593 },
  ],
  spawns: [
    { x: -35, y: 0, z: -23, yaw: 1.570796, team: "hunter" },
    { x: -31, y: 0, z: -23, yaw: 1.570796, team: "hunter" },
    { x: -27, y: 0, z: -23, yaw: 1.570796, team: "hunter" },
    { x: -35, y: 0, z: -9, yaw: 1.570796, team: "hunter" },
    { x: -31, y: 0, z: -9, yaw: 1.570796, team: "hunter" },
    { x: -27, y: 0, z: -9, yaw: 1.570796, team: "hunter" },
    { x: 23, y: 0, z: 23, yaw: 0.785398, team: "hider" },
    { x: 27, y: 0, z: 23, yaw: 0.865228, team: "hider" },
    { x: 31, y: 0, z: 23, yaw: 0.932477, team: "hider" },
    { x: 27, y: 0, z: 25, yaw: 0.823841, team: "hider" },
    { x: 31, y: 0, z: 25, yaw: 0.892134, team: "hider" },
    { x: 35, y: 0, z: 25, yaw: 0.950547, team: "hider" },
  ],
};
